import { Box, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import { NavLinkItem } from "./NavBar.types";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { useNavigate } from "react-router-dom";
import { logout } from "../redux/slices/auth.slice";
import { localUser } from "../utils/localUser";
import LogoutIcon from '@mui/icons-material/Logout';

type NavbarProps = {
    navComunLinks: NavLinkItem[];
    navAdminLinks: NavLinkItem[];
    setOpen: (value: boolean) => void;
};


export const NavListDrawer: React.FC<NavbarProps> = ({ navComunLinks, navAdminLinks, setOpen }) => {
    const {userData} = useAppSelector((state) => state.authReducer)
    const navigate = useNavigate();

    const dispatch = useAppDispatch();  
    const handleLogout = () => {
        dispatch(logout());
        localUser.borrar();
        navigate('/login');
    }
    return (
        <Box sx={{width:250}} role="presentation" >
            <List>
                {navComunLinks.map((link)=> (
                    <ListItem key = {link.path} disablePadding>
                        <ListItemButton onClick={()=> 
                            {
                                navigate(link.path); 
                                setOpen(false);
                            }}>
                            <ListItemIcon>
                                {link.icon}
                            </ListItemIcon>
                            <ListItemText primary={link.title} />
                        </ListItemButton>
                    </ListItem>
                ))}
                {userData?.role === "ADMIN" ? (
                    <>
                        <Divider />
                        {navAdminLinks.map((link)=> (
                            <ListItem key = {link.path} disablePadding>
                                <ListItemButton onClick={()=> {
                                    navigate(link.path);
                                    setOpen(false);
                                    }}>
                                    <ListItemIcon>
                                        {link.icon}
                                    </ListItemIcon>
                                    <ListItemText primary={link.title} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </>):
                    <></>
                }
                <Divider />
                <ListItem disablePadding>
                        <ListItemButton onClick={()=> {
                            handleLogout();
                            setOpen(false);
                            }}>
                            <ListItemIcon>
                                <LogoutIcon />
                            </ListItemIcon>
                            <ListItemText primary={"Logout"} />
                        </ListItemButton>
                </ListItem>
            </List>
        </Box>
    )
}